import React, { useRef } from "react";
import { Link } from "react-router-dom";
import water from '../../assets/inisitives photos/water conservation.JPG'
import tree from '../../assets/inisitives photos/tree plantation.JPG'
// import medical from '../../assets/medical.jpg'
import women from '../../assets/inisitives photos/mahercha umbhartha.jpeg'
import organic from'../../assets/inisitives photos/organic farming.JPG'
import ranbhaji from'../../assets/inisitives photos/ranbhaji.JPG'
import '../Initiative/initiative.css'

const Initiatives = () => {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="initiatives">
      <h2>Our Initiatives</h2>
      <div className="arrow left-arrow" onClick={scrollLeft}>
        &lt;
      </div>
      <div className="arrow right-arrow" onClick={scrollRight}>
        &gt;
      </div>
      <div className="initiative-container" ref={scrollRef}>
        <div className="initiative-card">
        <Link to="/projects#tree-plantation">
            <img src={tree} alt="Tree Plantation" className="initiative-image" />
        </Link>
          <h3>Tree Plantation </h3>
          <p>Helping to grow forests and reduce carbon footprint.</p>
          <Link to="/projects#tree-plantation">Learn More</Link>
        </div>
        
        <div className="initiative-card">
          <Link to="/projects#water-conservation">
            <img
              src={water}
              alt="Water Conservation"
              className="initiative-image"
            />
          </Link>
          <h3>Water Conservation</h3>
          <p>Rainwater to Reservoirs: A Conservation Journey.</p>
          <Link to="/projects#water-conservation">Learn More</Link>
        </div>
        <div className="initiative-card">
          <Link to="/projects#organic-farming">
            <img
              src={organic}
              alt="Organic Farming"
              className="initiative-image"
            />
          </Link>
          <h3>Organic Farming</h3>
          <p>Seeds of Change: Our Organic Farming Movement.</p>
          <Link to="/projects#organic-farming">Learn More</Link>
        </div>
        <div className="initiative-card">
          <Link to="/projects#women-development">
            <img
              src={women}
              alt="Women Development"
              className="initiative-image"
            />
          </Link>
          <h3>Mahercha Umbartha<p>(A True Maternal home)</p></h3>
          <p>Residential camp organized by women for women.</p>
          <Link to="/projects#women-development">Learn More</Link>
        </div>
        <div className="initiative-card">
          <Link to="/projects#wild-vegetable">
            <img
              src={ranbhaji}
              alt="Wild Vegetable"
              className="initiative-image"
            />
          </Link>
          <h3>RanBhaji Mohatsav</h3>
          <p>wild vegetables Festival.</p>
          <Link to="/projects#wild-vegetable">Learn More</Link>
        </div>
      </div>
    </section>
  );
};

export default Initiatives;
